"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachProps = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var call_both_1 = require("./call-both");
var merge_style_1 = require("./merge-style");
function attachProps(rawProps, newProps) {
    var e_1, _a;
    var props = {};
    try {
        for (var _b = tslib_1.__values(Object.entries(newProps)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), propName = _d[0], propValue = _d[1];
            if (typeof propValue === "function") {
                // 子节点之前已经有处理函数，则同时调用
                if (rawProps[propName]) {
                    props[propName] = call_both_1.callBoth(propValue, rawProps[propName]);
                }
                else {
                    props[propName] = propValue;
                }
            }
            else if (propName === "className") {
                props[propName] = classnames_1.default(rawProps.className, propValue);
            }
            else if (propName === "style") {
                props[propName] = merge_style_1.mergeStyle(rawProps.style, propValue);
            }
            else {
                props[propName] = propValue;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return props;
}
exports.attachProps = attachProps;
//# sourceMappingURL=attach-props.js.map